require('./bootstrap');

// Import modules...
import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';

import $ from 'jquery'
import __ from "@/common/trans";

window.$ = $;

Date.prototype.getFullMinutes = function () {
    if (this.getMinutes() < 10) {
        return '0' + this.getMinutes();
    }
    return this.getMinutes();
};

String.prototype.trimText = function (length) {
    return this.length > length ? this.substring(0, length) + "..." : this;
}
Object.filter = (obj, predicate) =>
    Object.keys(obj)
          .filter( key => predicate(obj[key]) )
          .reduce( (res, key) => (res[key] = obj[key], res), {} );

createInertiaApp({
    resolve: (name) => require(`./Pages/${name}`),
    setup({ el, app, props, plugin }) {

        const aplication = createApp({ render: () => h(app, props) })
        .mixin({
            methods: {
                route,
                __,
            }
        })
        .use(plugin);

        window.app = aplication.mount(el);

        document.getElementById('app').removeAttribute('data-page');
    },
});
InertiaProgress.init({
    color: '#4B5563',
    showSpinner: true,
})



function pureFadeIn(elem, display)
{
   var el = document.getElementById(elem);
   el.style.opacity = 0;
   el.style.display = display || "block";
   (function fade()
   {
      var val = parseFloat(el.style.opacity);
      if (!((val += .02) > 1))
      {
         el.style.opacity = val;
         requestAnimationFrame(fade);
      }
   })();
};
function pureFadeOut(elem)
{
   var el = document.getElementById(elem);
   el.style.opacity = 1;
   (function fade()
   {
      if ((el.style.opacity -= .02) < 0)
      {
         el.style.display = "none";
      }
      else
      {
         requestAnimationFrame(fade);
      }
   })();
};
